import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import StatusIcon from '../../../../../UI/StatusIcon'
import { DOCUMENT_TYPES } from '../../../../../shared/const'
import { localizedDocumentTypeLabel } from '../../../../../shared/helpers'

import styles from '../style.module.scss'

/*
 * Hinweiskasten oben im Reiter „Dokumente" (Anforderung #182).
 *
 * Schüler:innen und Lehrkräfte meldeten sich bei JAA, weil sie die
 * Einverständniserklärung zum Herunterladen nicht fanden — der Knopf steht an
 * der Karte, aber nichts sagte, dass es hier noch etwas zu tun gibt und wo.
 * Der Kasten nennt die Zahl, die fehlenden Dokumente beim Namen und den Ort
 * der Vorlagen. Sind alle da, bleibt eine schlichte Zeile.
 *
 * Die Liste kommt aus shared/missingDocuments — dieselbe, aus der der Punkt am
 * Reiter und das Dreieck in der Seitenleiste kommen.
 */
export default function DocumentsNotice({ missing, isTeacherStudentView }) {
	const { t } = useTranslation()

	if (!missing.length) {
		return (
			<p className={styles.documentsDone} role="status">
				<StatusIcon name="check" size={18} className={styles.documentsDoneIcon} />
				{t('All documents have been uploaded.')}
			</p>
		)
	}

	// Dieselben Namen wie die Überschriften der Karten darunter.
	const label = type =>
		type === DOCUMENT_TYPES.PARENTAL_CONFIRMATION
			? t('Consent of parent or guardian')
			: localizedDocumentTypeLabel(type)
	const names = missing.map(({ type }) => label(type)).join(', ')

	return (
		<div className={styles.documentsNotice} role="status">
			<StatusIcon name="warning" size={26} className={styles.documentsNoticeIcon} />
			<div>
				<p className={styles.documentsNoticeTitle}>
					{missing.length === 1
						? t('One document is still missing.')
						: t('Several documents are still missing.', { count: missing.length })}
				</p>
				<p className={styles.documentsNoticeText}>
					{names}
					{/* In der Schüler:innen-Ansicht der Lehrkraft gibt es weder
					    Hochladen noch Vorlage — der zweite Satz wäre dort falsch. */}
					{!isTeacherStudentView && (
						<>
							<br />
							{t(
								'You will find the templates to download and the upload field directly with each document below.'
							)}
						</>
					)}
				</p>
			</div>
		</div>
	)
}

DocumentsNotice.propTypes = {
	missing: PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string, rejected: PropTypes.bool })).isRequired,
	isTeacherStudentView: PropTypes.bool
}
